import type { Location } from "react-router-dom";

// Settings remembers the page it was opened from in the location's state, so Back returns there.
export type TSettingsState = { settingsFrom?: string };

export const settingsFrom = (location: Location) => (location.state as TSettingsState | null)?.settingsFrom;
